import React from 'react';
import TemplateField from 'containers/Mail/FormFields/TemplateField';
import ToggleMultiMode from 'containers/Mail/SendEmails/ToggleMultiMode';
import UploadCSVToSimulate from './UploadCSVToSimulate';
import TargetDateSelector from './TargetDateSelector';

export default function SimulateThrottleCSVForm() {
  return (
    <>
      <ToggleMultiMode showRegardless />
      <TemplateField />
      <TargetDateSelector />
      <div style={{ marginTop: 20 }}>
        <UploadCSVToSimulate />
      </div>
    </>
  );
}
